// extracted by mini-css-extract-plugin
export var notificationHost = "_hc-0";